module.exports = __webpack_public_path__ + "img/icon-colorful-eth.82aab93b.svg";